<template>
  <div class="teamdetail" :class="[bigpicFlag||dahuiFlag?'stopscroll':'']">
    <div class="titlegroup">
      <div class="oneline name">
        {{name}}
      </div>
      <div class="downbtn"
            v-show="nownum!==0"
            @click="plxz">批量下载</div>
    </div>
    <div class="progresswrap">
      拍摄进度
      <div>{{nownum}}/{{totalnum}}</div>
    </div>
    <mt-progress :value="nownum | teampercent(totalnum)" :bar-height="5"></mt-progress>
    <search-rule v-if="list.length===0&&!loadingTxt" :searchStatus="6" ></search-rule>
    <div class="photolist">
        <div v-for="(item, index) in list"
             :key="item.order_id"
             class="photo"
             @click="bigphotoshow(item, index)">
            <div class="photoimgwrap">
            <img class="photoimg" :src="item.final_pic_name[0]" />
            <div v-if="item.is_back===1" class="yidahui">
                <img src="@/assets/gantan.png" class="gantanimg" />
                <div class="photofanhui">已打回</div>
            </div>
            </div>
            <div class="phototxt oneline">{{item.information | handleInformation}}</div>
        </div>
        <div class="photonone"></div>
    </div>
    <div class="btngroup">
      <div class="btnmore btn" :class="[is_visible===1?'flexgrow1':'']" @click="openshare('2')">更多</div>
      <div v-if="is_visible!==1" class="btnshare btn" @click="openshare('1')">分享至团员</div>
    </div>
    <popup :showFlag="shareFlag !== '0'"
           @onShowpop="shareFlag='0'">
      <div class="sharebtn toshare"
              v-if="shareFlag === '1'"
              @click="shareinfo">直接分享</div>
      <div class="sharebtn erweima" @click="steptwo">{{shareFlag==='1'?'保存二维码':'修改截止日期'}}</div>
      <div class="sharebtn cancelbtn" @click="shareFlag='0'">取消</div>
    </popup>
    <div class="bigpicmask" v-show="bigpicFlag">
      <div class="bigpiccot">
        <img :src="[selObj.final_pic_name ? selObj.final_pic_name[0] : '']" class="bigimg" />
        <div class="bigdetail">{{selObj.information|handleInformation}}</div>
      </div>
      <div class="bigimgbtngroup">
        <div class="backbtn" v-if="teamState === '进行中' && is_visible !== 1" @click="backphoto">打回照片</div>
        <div class="closebtn" @click="bigpicFlag = false">关闭</div>
      </div>
    </div>
    <div class="bigpicmask" v-show="dahuiFlag">
      <div class="callbackwrap">
        <div class="cbwraptitle">照片不合格原因</div>
        <div class="cbwrapcot">该照片打回后，请通知拍摄者重新拍摄，第一次打回拍摄者可以免费拍摄同价格的证件照，若再次提交后仍被打回则需要重新缴费</div>
        <div class="cbwrapipt">
          <input v-model="reason" class="cbipt" placeholder="输入不合格原因" />
        </div>
        <div class="bigimgbtngroup">
          <div class="backbtn" @click="surebackphoto">确认打回</div>
          <div class="closebtn" @click="sureclosebigimg">取消</div>
        </div>
      </div>
    </div>
    <datetime-picker v-if="create_time"
                     ref="picker"
                     type="date"
                     :startDate="create_time"
                     v-model="end_time"
                     :endDate="timeEnd"
                     year-format="{value} 年"
                     month-format="{value} 月"
                     date-format="{value} 日"
                     @confirm="handleConfirm"></datetime-picker>
    <save-ele :showFlag="saveFlag"
              :extract_str="extract_code"
              :isCollect="true"
              :savephoto="false"
              :isVisible="true"
              downurl="www.id-photo-verify.com/t2"
              :orderid="project_no"
              @onCloseEleSave="saveFlag = false"></save-ele>
    <share @hidewrap="shareWrapFlag=false" :showFlag="shareWrapFlag"></share>
    <qrcode channel="detail"></qrcode>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { Progress, MessageBox, DatetimePicker } from 'mint-ui'
import { getShareUrl } from '@/utils/utils'
import popup from '@/components/popup'
import searchRule from '@/components/searchRule/searchRule'
import saveEle from '@/components/saveEle/saveEle'
import share from '@/components/share/share'
import qrcode from '@/components/qrcode/qrcode'
export default {
  name: 'teamdetail',
  data () {
    return {
      list: [],
      selIdx: -1,
      totalnum: 0,
      is_visible: 0,
      extract_code: '',
      nownum: 0,
      name: '',
      project_no: '',
      shareFlag: '0', // 0为关闭1为分享2为更多
      selObj: {},
      bigpicFlag: false,
      dahuiFlag: false,
      reason: '',
      create_time: null,
      end_time: null,
      idx: -1, // 这是列表带过来的位置索引
      saveFlag: false,
      extract_str: '111',
      shareWrapFlag: false
    }
  },
  created () {
    this.saveFlag = false
    const { idx, info, needShare = false } = this.$route.params
    console.log('needShare:::', needShare)
    this.idx = idx
    this.shareWrapFlag = needShare
    this.setShare(info)
    const {
      actual_quantity,
      project_name,
      total_quantity,
      is_visible,
      project_no,
      create_time,
      extract_code,
      color_china,
      spec_name,
      end_time
    } = info
    this.name = project_name
    this.nownum = actual_quantity
    this.totalnum = total_quantity
    this.project_no = project_no
    this.create_time = new Date(create_time)
    this.end_time = new Date(end_time)
    this.extract_code = extract_code
    this.is_visible = is_visible
    this.color_china = color_china
    this.spec_name = spec_name
    this.getphotolist(project_no)
  },
  methods: {
    ...mapActions(['getOwnerDetailA', 'updatetimeA', 'refundpicA']),
    setShare (info) {
      console.log(11111)
      const { project_name, project_no, spec_name, color_china } = info
      wx.ready(function () {
        wx.updateAppMessageShareData({
          title: project_name, // 分享标题
          desc: `${spec_name} | ${color_china}`, // 分享描述
          link: getShareUrl(project_no), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://leqi-public.oss-cn-shanghai.aliyuncs.com/wechat_applet/collect_share.jpg' // 分享图标
        })
        wx.onMenuShareAppMessage({
          title: project_name, // 分享标题
          desc: `${spec_name} | ${color_china}`, // 分享描述
          link: getShareUrl(project_no), // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: 'https://leqi-public.oss-cn-shanghai.aliyuncs.com/wechat_applet/collect_share.jpg' // 分享图标
        })
      })
    },
    getphotolist (project_no) {
      this.getOwnerDetailA(project_no).then(res => {
        const { data } = res
        this.list = data
      })
    },
    openshare (type) {
      this.shareFlag = type
    },
    bigphotoshow (item, idx) {
      if (item.is_back === 1) {
        return
      }
      this.selObj = item
      this.selIdx = idx
      this.bigpicFlag = true
    },
    surebackphoto () {
      let { reason, selObj: { order_id }, selIdx, list, nownum, idx } = this
      if (!reason) {
        MessageBox.alert('请输入不合格原因')
        return
      }
      const data = {
        refuse_reason: reason,
        order_id
      }
      this.refundpicA(data).then(res => {
        MessageBox.alert('打回成功')
        list[selIdx].is_back = 1
        nownum--
        this.$bus.emit('mt_backphoto', idx, nownum)
        this.dahuiFlag = false
        this.list = list
        this.nownum = nownum
      })
    },
    sureclosebigimg () {
      this.bigpicFlag = true
      this.dahuiFlag = false
      this.reason = ''
    },
    shareinfo () {
      this.shareFlag = '0'
      console.log('分享啦')
      this.shareWrapFlag = true
    },
    steptwo () {
      const { shareFlag } = this
      const fnname = shareFlag === '1' ? this.saveQrcode : this.modifyTime
      fnname.call(this)
    },
    modifyTime () {
      this.$refs.picker.open()
    },
    backphoto () {
      console.log('打回')
      this.bigpicFlag = false
      this.dahuiFlag = true
    },
    saveQrcode () {
      this.shareFlag = '0'
      const { project_no } = this
      this.$bus.emit('detailqrcode', project_no)
    },
    handleConfirm (e) {
      const { project_no, idx } = this
      const time = new Date(e)
      const selTime = `${time.getFullYear()}-${time.getMonth() + 1}-${time.getDate()}`
      const obj = {
        project_no,
        end_time: selTime
      }
      this.updatetimeA(obj).then(res => {
        this.$bus.emit('mt_modifytime', idx, selTime)
        this.timeFlag = false
        this.shareFlag = '0'
        this.end_time = new Date(selTime)
      })
    },
    plxz () {
      const { totalnum, nownum } = this
      if (nownum < totalnum) {
        MessageBox.confirm('团体照还未收齐，确认下载？').then(action => {
          this.saveFlag = true
        }).catch(err => {
          console.log(err)
        })
        return
      }
      this.saveFlag = true
    }
  },
  computed: {
    ...mapState(['isIos', 'loadingTxt', 'actiBol']),
    timeEnd () {
      const endTime = new Date(this.create_time)
      endTime && endTime.setDate(endTime.getDate() + 59) // 默认60天为活动最长到期时间
      return endTime
    },
    teamState () {
      const { end_time: end } = this
      const endTime = new Date(end).getTime()
      const nowd = new Date()
      const nowTime = new Date(nowd.getFullYear(), nowd.getMonth(), nowd.getDate()).getTime()
      const txt = nowTime > endTime ? '已结束' : '进行中'
      return txt
    }
  },
  filters: {
    teampercent (nowunm, totalnum) {
      nowunm = nowunm <= totalnum ? nowunm : totalnum
      return Math.ceil(nowunm / totalnum * 100)
    },
    handleInformation (obj) {
      obj = obj || {}
      const desc = Object.keys(obj).reduce((val, item) => {
        return val + ` ${obj[item]}`
      }, '')
      return desc
    }
  },
  components: {
    mtProgress: Progress,
    searchRule,
    popup,
    DatetimePicker,
    saveEle,
    share,
    qrcode
  }
}
</script>

<style>
.teamdetail .mt-progress-progress{
  background-color: #4710ED;
}
</style>

<style scoped>
.teamdetail{
  box-sizing: border-box;
  padding:.16rem .4rem 0;
  min-height: 100%;
  background-color: white;
}
.titlegroup{
  display: flex;
  display: -webkit-flex;
  margin-bottom: .48rem;
  align-items: center;
}
.name{
  font-size: .48rem;
  font-weight: bold;
  color:#303133;
  flex-grow:1;
}
.downbtn{
  flex-shrink: 0;
  font-size: .24rem;
  color:#303133;
  width:1.6rem;
  height:.64rem;
  border-radius: .12rem;
  border:.02rem solid #E5E5EA;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  margin-left: .1rem;
}
.downactive{
  background-color: #ccc;
  color:white;
}
.progresswrap{
  font-size: .28rem;
  color:#303133;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  margin-bottom: .16rem;
}
.btngroup{
  position: fixed;
  width:100%;
  bottom:0;
  left:0;
  display: flex;
  display: -webkit-flex;
  box-sizing: border-box;
  padding:0 .4rem;
  justify-content: space-between;
  font-size: .34rem;
  align-items: center;
  background-color: white;
  padding-top: .32rem;
}
.btn{
  text-align: center;
  height:.96rem;
  font-weight: bold;
  border-radius: .12rem;
  margin-bottom: .32rem;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  width:49%;
}
.btnmore{
  border:.04rem solid #4710ED;
  color:#4710ED;
}
.flexgrow1{
  flex-grow: 1;
}
.btnshare{
  background-color: #4710ED;
  color:white;
}
.sharebtn{
  background-color: white;
  text-align: center;
  font-size: .34rem;
  color:#303133;
  height:1.12rem;
  line-height: 1.12rem;
}
.toshare{
  border-top-left-radius: .24rem;
  border-top-right-radius: .24rem;
  border-bottom:.02rem solid #E5E5EA;
}
.erweima{
  border-bottom: .16rem solid #F5F7FA;
}
.cancelbtn{
  padding-bottom: .32rem;
  color:#ADADAE;
}
.photolist{
  margin-top: .64rem;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-bottom:1.6rem;
}
.photonone{
   width:32%;
   flex-shrink: 0;
}
.photo{
  width:32%;
  margin-bottom: .32rem;
  font-size: .26rem;
  color:#303133;
  flex-shrink: 0;
  text-align: center;
}
.photoimgwrap{
  width:2.14rem;
  height:3rem;
  margin-bottom: .16rem;
  position: relative;
}
.yidahui{
  position: absolute;
  width:100%;
  height:100%;
  left:0;
  top:0;
  font-size: .28rem;
  color:white;
  background-color: rgba(0, 0, 0, 0.6);
  text-align: center;
  display: flex;
  display: -webkit-flex;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
}
.gantanimg{
  display: block;
  width:.64rem;
  height:.64rem;
  object-fit: contain;
}
.photofanhui{
  width:100%;
  margin-top: .16rem;
}
.photoimg{
  width:100%;
  height:100%;
  object-fit: cover;
}
.stopscroll{
  height:100%;
  position: absolute;
  left:0;
  top:0;
  width:100%;
  overflow: hidden;
  box-sizing: border-box;
  padding:.16rem .4rem 0;
}
.bigpicmask{
  position: fixed;
  width:100%;
  height:100%;
  left:0;
  top:0;
  background-color: rgba(0,0,0,0.4);
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
}
.bigpiccot{
  background-color: white;
  width:5.6rem;
  height:9.68rem;
  overflow-x: hidden;
  overflow-y: auto;
  position: relative;
  box-sizing: border-box;
}
.bigimg{
  width:5.6rem;
  display: block;
}
.bigimgbtngroup{
  width: 5.6rem;
  background-color: white;
  align-items: center;
  justify-content: space-between;
  display: flex;
  display: -webkit-flex;
  border-top:.02rem solid rgba(25, 31, 37, 0.08);
}
.backbtn,.closebtn{
  height:.88rem;
  line-height: .88rem;
  width:50%;
  box-sizing: border-box;
  text-align: center;
  font-size: .34rem;
  color:#303133;
}
.closebtn{
  flex-grow:1;
}
.backbtn{
  color:#F25643;
  border-right: .02rem solid rgba(25, 31, 37, 0.08);
}
.activebtn{
  background-color: #ccc;
  color:white;
}
.bigdetail{
  font-size: .34rem;
  color:#303133;
  text-align: center;
  padding:.22rem;
  box-sizing: border-box;
  word-break: break-all;
}
.callbackwrap{
  background-color: white;
  border-radius: .06rem;
  width:5.6rem;
  padding-top: .48rem;
}
.cbwraptitle{
  font-size: .34rem;
  color:#303133;
  font-weight: bold;
  text-align: center;
  margin-bottom: .16rem;
}
.cbwrapcot{
  font-size: .26rem;
  color:#838485;
  text-align: center;
  width:4.64rem;
  margin:0 auto .32rem;
  line-height: .36rem;
}
.cbwrapipt{
  font-size: .26rem;
  width:4.64rem;
  border:1px solid #E5E5EA;
  border-radius: .16rem;
  margin:0 auto .4rem;
  overflow: hidden;
}
.cbipt{
  border:none;
  width:100%;
  height: 0.72rem;
  display: block;
  text-indent: 1em;
  font-size: .26rem;
}
</style>
